"use client";
import { FC } from "react";
import classNames from "classnames";

import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

type TProps = {
  children: React.ReactNode;
};

const LoginAndPassRecoveryLayout: FC<TProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <div className="flex w-full items-center justify-center lg:justify-between">
      <div className="w-full lg:max-w-[448px]">{children}</div>
      <div className="hidden w-full rounded-[20px] !bg-neutral-100 py-[88px] pl-[57px] lg:ml-[150px] lg:block lg:h-[500px] lg:max-w-[865px] 2xl:h-[43.75rem]">
        <div
          className={classNames("h-full", {
            "login-bg-boxette": theme !== Theme.UK && theme !== Theme.UZ,
            "login-bg-easyXpress": theme === Theme.UK,
            "login-bg-uz": theme === Theme.UZ,
          })}
        />
      </div>
    </div>
  );
};

export default LoginAndPassRecoveryLayout;
